import { render, staticRenderFns } from "./PiePagina.vue?vue&type=template&id=33abcf9c&scoped=true&"
import script from "./PiePagina.vue?vue&type=script&lang=js&"
export * from "./PiePagina.vue?vue&type=script&lang=js&"
import style0 from "./PiePagina.vue?vue&type=style&index=0&id=33abcf9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abcf9c",
  null
  
)

export default component.exports